module.exports = __webpack_public_path__ + "img/9_57.8451ba28.png";